enum BoundaryType {
  TERRITORY = "territory",
  GEOGRAPHY = "geography",
}

export default BoundaryType;
